export default function formatTime(ms) {
  if (!ms || typeof ms !== 'number' || ms < 0) return '00:00';

  ms = Math.floor(ms);
  const seconds = Math.floor(ms / 1000) % 60;
  const minutes = Math.floor(ms / 60000);

  return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
}

